import { motion } from "framer-motion";
import { ArrowRight, Play, ShieldCheck, Zap, Star } from "lucide-react";

export const Hero = ({ stats }) => {
  return (
    <section className="relative overflow-hidden border-b border-white/10 terminal-grid">
      {/* backdrop */}
      <div className="pointer-events-none absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1762279388952-85187155e48d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
          alt=""
          className="h-full w-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-slate-950/70" />
        <div className="absolute left-1/2 top-0 h-[400px] w-[600px] -translate-x-1/2 rounded-full bg-emerald-500/10 blur-[120px]" />
      </div>

      <div className="relative mx-auto grid max-w-[1400px] grid-cols-1 gap-10 px-6 py-20 lg:grid-cols-12 lg:px-10 lg:py-28">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-8"
        >
          <div className="mb-6 inline-flex items-center gap-2 border border-emerald-500/30 bg-emerald-500/10 px-3 py-1.5 font-mono text-xs uppercase tracking-[0.2em] text-emerald-300">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-emerald-400" />
            Live market · prices tick every 60s
          </div>
          <h1 className="font-display text-4xl font-black uppercase leading-[0.95] tracking-tight text-white sm:text-5xl lg:text-7xl">
            The exchange for
            <br />
            <span className="text-emerald-400">premium templates.</span>
          </h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-slate-300">
            Ticker Templates prices every asset against the live market — Notion, Excel, Figma and more.
            Our engine tracks competitor averages by the second and locks in the <span className="text-emerald-400">best market value</span>, so you always trade below street price.
          </p>
          <div className="mt-9 flex flex-wrap items-center gap-4">
            <a
              href="#marketplace"
              data-testid="hero-primary-cta"
              className="group inline-flex items-center gap-2 bg-emerald-500 px-6 py-3.5 font-mono text-sm font-bold uppercase tracking-wide text-slate-950 transition-[background-color] duration-200 hover:bg-emerald-400"
            >
              Open the Market
              <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
            </a>
            <a
              href="#autopilot"
              data-testid="hero-secondary-cta"
              className="inline-flex items-center gap-2 border border-cyan-400/40 px-6 py-3.5 font-mono text-sm font-medium uppercase tracking-wide text-cyan-400 transition-colors duration-200 hover:border-cyan-400"
            >
              <Play className="h-4 w-4" /> The Autopilot Desk
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-6 text-sm text-slate-400">
            <span className="flex items-center gap-2">
              <ShieldCheck className="h-4 w-4 text-emerald-400" /> Instant secure download
            </span>
            <span className="flex items-center gap-2">
              <Star className="h-4 w-4 text-emerald-400" /> {stats?.avg_rating || "4.8"} avg rating
            </span>
          </div>
        </motion.div>

        {/* Stats bento */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="grid grid-cols-2 gap-px self-start border border-white/10 bg-white/10 lg:col-span-4"
        >
          {[
            { label: "Templates Live", value: stats?.templates ?? "—", icon: Zap },
            { label: "Avg Savings", value: "34%", icon: TrendingIcon },
            { label: "Downloads", value: stats ? `${(stats.total_sales / 1000).toFixed(1)}k` : "—", icon: ArrowRight },
            { label: "On Autopilot", value: stats?.subscribers ?? "—", icon: ShieldCheck },
          ].map((s) => (
            <div key={s.label} className="bg-slate-900 p-6">
              <s.icon className="mb-4 h-5 w-5 text-emerald-400" />
              <div className="font-mono text-3xl font-bold text-white">{s.value}</div>
              <div className="mt-1 font-mono text-xs uppercase tracking-[0.15em] text-slate-500">
                {s.label}
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

function TrendingIcon(props) {
  return <Zap {...props} />;
}

export default Hero;
